import { PATHS } from 'constants';
import ListUser from './components/ListContent/ListUser';

export default function User({ user }) {
  const userLink = PATHS.profile.replace(':userId', user.id);

  return (
    <ListUser user={user} link={userLink} />
  );
}
